<template>
  <a-drawer
    :title="title"
    :width="width"
    placement="right"
    :closable="false"
    @close="close"
    :visible="visible">
  
    <a-spin :spinning="confirmLoading">
      <a-form :form="form">

        <a-form-item label="数据库地址" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="[ 'databaseAddress', validatorRules.databaseAddress]" placeholder="请输入数据库地址"></a-input>
        </a-form-item>
        <a-form-item label="数据库名称" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="[ 'databaseName', validatorRules.databaseName]" placeholder="请输入数据库名称"></a-input>
        </a-form-item>
        <a-form-item label="数据库大小" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="[ 'databaseSpaceSize', validatorRules.databaseSpaceSize]" placeholder="请输入数据库大小"></a-input>
        </a-form-item>
        <a-form-item label="数据库类型和版本" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="[ 'databaseType', validatorRules.databaseType]" placeholder="请输入数据库类型和版本"></a-input>
        </a-form-item>
        <a-form-item label="所属业务" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="[ 'business', validatorRules.business]" placeholder="请输入所属业务"></a-input>
        </a-form-item>
        <a-form-item label="业务应用说明" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="[ 'applicationDescription', validatorRules.applicationDescription]" placeholder="请输入业务应用说明"></a-input>
        </a-form-item>
        <a-form-item label="负责人" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="[ 'responsiblePerson', validatorRules.responsiblePerson]" placeholder="请输入负责人"></a-input>
        </a-form-item>
        <a-form-item label="是否备份" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <j-dict-select-tag type="list" v-decorator="['isBackup', validatorRules.isBackup]" :trigger-change="true" dictCode="backup_or_not" placeholder="请选择是否备份"/>
        </a-form-item>
        <a-form-item label="备份策略" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <j-dict-select-tag type="list" v-decorator="['backupStrategy', validatorRules.backupStrategy]" :trigger-change="true" dictCode="backup_policy" placeholder="请选择备份策略"/>
        </a-form-item>
        <a-form-item label="备份机制" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <j-dict-select-tag type="list" v-decorator="['backupMechanism', validatorRules.backupMechanism]" :trigger-change="true" dictCode="backup_mech" placeholder="请选择备份机制"/>
        </a-form-item>
        <a-form-item label="备份服务器及所在路径" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="[ 'backupPath', validatorRules.backupPath]" placeholder="请输入备份服务器及所在路径"></a-input>
        </a-form-item>
        <a-form-item label="存储介质" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <j-dict-select-tag type="list" v-decorator="['storageMedium', validatorRules.storageMedium]" :trigger-change="true" dictCode="storage_medium" placeholder="请选择存储介质"/>
        </a-form-item>
        <a-form-item label="备份时间点" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="[ 'backupTimePoint', validatorRules.backupTimePoint]" placeholder="请输入备份时间点"></a-input>
        </a-form-item>
        <a-form-item label="备份频率" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="[ 'backupFrequency', validatorRules.backupFrequency]" placeholder="请输入备份频率"></a-input>
        </a-form-item>
        <a-form-item label="备份时长" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="[ 'backupTime', validatorRules.backupTime]" placeholder="请输入备份时长"></a-input>
        </a-form-item>
        <a-form-item label="保留备份天数" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="[ 'retentionDays', validatorRules.retentionDays]" placeholder="请输入保留备份天数"></a-input>
        </a-form-item>
        <a-form-item label="备份文件大小(单个)" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="[ 'backupFileSize', validatorRules.backupFileSize]" placeholder="请输入备份文件大小(单个)"></a-input>
        </a-form-item>
        <a-form-item label="备注" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="[ 'remark', validatorRules.remark]" placeholder="请输入备注"></a-input>
        </a-form-item>
        
      </a-form>
    </a-spin>
    <a-button type="primary" @click="handleOk">确定</a-button>
    <a-button type="primary" @click="handleCancel">取消</a-button>
  </a-drawer>
</template>

<script>

  import { httpAction } from '@/api/manage'
  import pick from 'lodash.pick'
  import { validateDuplicateValue } from '@/utils/util'
  import JDictSelectTag from "@/components/dict/JDictSelectTag"
  
  export default {
    name: "BusAssetStorageDetailModal",
    components: { 
      JDictSelectTag,
    },
    data () {
      return {
        form: this.$form.createForm(this),
        title:"操作",
        width:800,
        visible: false,
        model: {},
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
        confirmLoading: false,
        validatorRules: {
          databaseAddress: {rules: [
          ]},
          databaseName: {rules: [
          ]},
          databaseSpaceSize: {rules: [
          ]},
          databaseType: {rules: [
          ]},
          business: {rules: [
          ]},
          applicationDescription: {rules: [
          ]},
          responsiblePerson: {rules: [
          ]},
          isBackup: {rules: [
          ]},
          backupStrategy: {rules: [
          ]},
          backupMechanism: {rules: [
          ]},
          backupPath: {rules: [
          ]},
          storageMedium: {rules: [
          ]},
          backupTimePoint: {rules: [
          ]},
          backupFrequency: {rules: [
          ]},
          backupTime: {rules: [
          ]},
          retentionDays: {rules: [
          ]},
          backupFileSize: {rules: [
          ]},
          remark: {rules: [
          ]},
        },
        url: {
          add: "/assetstorage.base/busAssetStorageDetail/add",
          edit: "/assetstorage.base/busAssetStorageDetail/edit",
        }
      }
    },
    created () {
    },
    methods: {
      add () {
        this.edit({});
      },
      edit (record) {
        this.form.resetFields();
        this.model = Object.assign({}, record);
        this.visible = true;
        this.$nextTick(() => {
          this.form.setFieldsValue(pick(this.model,'databaseAddress','databaseName','databaseSpaceSize','databaseType','business','applicationDescription','responsiblePerson','isBackup','backupStrategy','backupMechanism','backupPath','storageMedium','backupTimePoint','backupFrequency','backupTime','retentionDays','backupFileSize','remark'))
        })
      },
      close () {
        this.$emit('close');
        this.visible = false;
      },
      handleOk () {
        const that = this;
        // 触发表单验证
        this.form.validateFields((err, values) => {
          if (!err) {
            that.confirmLoading = true;
            let httpurl = '';
            let method = '';
            if(!this.model.id){
              httpurl+=this.url.add;
              method = 'post';
            }else{
              httpurl+=this.url.edit;
               method = 'post';
            }
            let formData = Object.assign(this.model, values);
            console.log("表单提交数据",formData)
            httpAction(httpurl,formData,method).then((res)=>{
              if(res.success){
                that.$message.success(res.message);
                that.$emit('ok');
              }else{
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
              that.close();
            })
          }
         
        })
      },
      handleCancel () {
        this.close()
      },
      popupCallback(row){
        this.form.setFieldsValue(pick(row,'databaseAddress','databaseName','databaseSpaceSize','databaseType','business','applicationDescription','responsiblePerson','isBackup','backupStrategy','backupMechanism','backupPath','storageMedium','backupTimePoint','backupFrequency','backupTime','retentionDays','backupFileSize','remark'))
      }
      
    }
  }
</script>

<style lang="less" scoped>
/** Button按钮间距 */
  .ant-btn {
    margin-left: 30px;
    margin-bottom: 30px;
    float: right;
  }
</style>